import React, { BaseSyntheticEvent } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import SingleSelectPage from '../../../components/singleSelectPage/SingleSelectPage.component'
import { useHistory } from 'react-router'
import { getActionsList } from '../selectors/getActionsList.selector'
import { onSelectMedicationAdministered } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { useTranslation } from 'react-i18next'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import {
  onSelectIntubationProcedure,
  resetState as resetIntubationState,
} from '../../intubation/store/intubation.actions'
import {
  onSelectCardiacProcedure,
  resetState as resetCardiacState,
} from '../../procedures/cardiac/store/cardiac.actions'
import { onSelectAirwayProcedure, resetState as resetAirwayState } from '../../procedures/airway/store/airway.actions'
import {
  onSelectChildbirthOBProcedure,
  resetState as resetChildbirthOBState,
} from '../../procedures/childbirthOB/store/childbirthOB.actions'
import {
  onSelectInitiateIvProcedure,
  resetState as resetInitiateIvState,
} from '../../procedures/initiateIv/store/initiateIv.actions'
import {
  onSelectImmobilizationProcedure,
  resetState as resetImmobilizationState,
} from '../../procedures/immobilization/store/immobilization.actions'
import {
  onSelectMedicalConsultProcedure,
  resetState as resetMedicalConsultState,
} from '../../procedures/medicalConsult/store/medicalConsult.actions'
import {
  onSelectExtricationProcedure,
  resetState as resetExtricationState,
} from '../../procedures/extrication/store/extrication.actions'
import {
  onSelectOperationsProcedure,
  resetState as resetOperationsState,
} from '../../procedures/operations/store/operations.actions'
import { onSelectRescueProcedure, resetState as resetRescueState } from '../../procedures/rescue/store/rescue.actions'
import {
  onSelectVentilatorProcedure,
  resetState as resetVentilatorState,
} from '../../procedures/ventilator/store/ventilator.actions'
import {
  onSelectHospitalNotifyProcedure,
  resetState as resetHospitalNotifyState,
} from '../../procedures/hospitalNotify/store/hospitalNotify.actions'
import {
  onSelectWoundCareProcedure,
  resetState as resetWoundCareState,
} from '../../procedures/woundCare/store/woundCare.actions'
import { resetState as resetMedicationAdministeredState } from '../../addMedicationAdministered/store/addMedicationAdministered.actions'
import { onSelectDrainProcedure, resetState as resetDrainState } from '../../procedures/drain/store/drain.actions'
import {
  onSelectBloodProductAdministrationProcedure,
  resetState as resetBloodProductAdministrationState,
} from '../../procedures/bloodProductAdministration/store/bloodProductAdministration.actions'
import {
  onSelectVentricularAssistDeviceProcedure,
  resetState as resetVentricularAssistDeviceState,
} from '../../procedures/ventricularAssistDevice/store/ventricularAssistDevice.actions'
import {
  onSelectCriticalCareProcedure,
  resetState as resetCriticalCareState,
} from '../../procedures/criticalCare/store/criticalCare.actions'
import {
  onSelectAssessmentProcedure,
  resetState as resetAssessmentState,
} from '../../procedures/assessment/store/assessment.actions'
import { resetState as resetImagingUltrasoundState } from '../../procedures/imagingUltrasound/store/ImagingUltrasound.actions'
import { resetLabsState as resetLabsProcedureState } from '../../procedures/labs/store/labs.actions'
import { resetPnMedicationState as resetPnMedicationsState } from '../../procedures/pnMedication/store/pnMedication.actions'
import { resetState as resetPertinentNegativeProcedureState } from '../../procedures/pnProcedure/store/pnProcedure.actions'
import { resetTitrateState as resetTitrateProcedureState } from '../../procedures/titrate/store/titrate.actions'

const ActionsSearch: React.FC = () => {
  const history = useHistory()
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const actionsList = useSelector(getActionsList)

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.TIMELINE_TAB)
  }

  const onActionClick = (e: BaseSyntheticEvent, option: any) => {
    e.preventDefault()
    history.push(option.action)
    switch (option.action) {
      case TabConstants.ADD_MEDICATIONS_ADMINISTERED:
        dispatch(onSelectMedicationAdministered())
        dispatch(resetMedicationAdministeredState())
        return
      case TabConstants.INTUBATION_PROCEDURE:
        dispatch(onSelectIntubationProcedure())
        dispatch(resetIntubationState())
        return
      case TabConstants.CARDIAC_PROCEDURE:
        dispatch(onSelectCardiacProcedure())
        dispatch(resetCardiacState())
        return
      case TabConstants.LABS_PROCEDURE:
        dispatch(resetLabsProcedureState())
        return
      case TabConstants.DRAIN_PROCEDURE:
        dispatch(onSelectDrainProcedure())
        dispatch(resetDrainState())
        return
      case TabConstants.AIRWAY_PROCEDURE:
        dispatch(onSelectAirwayProcedure())
        dispatch(resetAirwayState())
        return
      case TabConstants.CHILDBIRTHOB_PROCEDURE:
        dispatch(onSelectChildbirthOBProcedure())
        dispatch(resetChildbirthOBState())
        return
      case TabConstants.INITIATE_IV_PROCEDURE:
        dispatch(onSelectInitiateIvProcedure())
        dispatch(resetInitiateIvState())
        return
      case TabConstants.IMMOBILIZATION_PROCEDURE:
        dispatch(onSelectImmobilizationProcedure())
        dispatch(resetImmobilizationState())
        return
      case TabConstants.MEDICAL_CONSULT_PROCEDURE:
        dispatch(onSelectMedicalConsultProcedure())
        dispatch(resetMedicalConsultState())
        return
      case TabConstants.EXTRICATION_PROCEDURE:
        dispatch(onSelectExtricationProcedure())
        dispatch(resetExtricationState())
        return
      case TabConstants.IMAGING_ULTRASOUND_PROCEDURE:
        dispatch(resetImagingUltrasoundState())
        return
      case TabConstants.OPERATIONS_PROCEDURE:
        dispatch(onSelectOperationsProcedure())
        dispatch(resetOperationsState())
        return
      case TabConstants.RESCUE_PROCEDURE:
        dispatch(onSelectRescueProcedure())
        dispatch(resetRescueState())
        return
      case TabConstants.TITRATE_PROCEDURE:
        dispatch(resetTitrateProcedureState())
        return
      case TabConstants.VENTILATOR_PROCEDURE:
        dispatch(onSelectVentilatorProcedure())
        dispatch(resetVentilatorState())
        return
      case TabConstants.HOSPITAL_NOTIFY_PROCEDURE:
        dispatch(onSelectHospitalNotifyProcedure())
        dispatch(resetHospitalNotifyState())
        return
      case TabConstants.WOUND_CARE_PROCEDURE:
        dispatch(onSelectWoundCareProcedure())
        dispatch(resetWoundCareState())
        return
      case TabConstants.BLOOD_PRODUCT_ADMINISTRATION_PROCEDURE:
        dispatch(onSelectBloodProductAdministrationProcedure())
        dispatch(resetBloodProductAdministrationState())
        return
      case TabConstants.VENTRICULAR_ASSIST_DEVICE_PROCEDURE:
        dispatch(onSelectVentricularAssistDeviceProcedure())
        dispatch(resetVentricularAssistDeviceState())
        return
      case TabConstants.CRITICAL_CARE_PROCEDURE:
        dispatch(onSelectCriticalCareProcedure())
        dispatch(resetCriticalCareState())
        return
      case TabConstants.ASSESSMENT_PROCEDURE:
        dispatch(onSelectAssessmentProcedure())
        dispatch(resetAssessmentState())
        return
      case TabConstants.PN_MEDICATION_PROCEDURE:
        dispatch(resetPnMedicationsState())
        return
      case TabConstants.PERTINENT_NEGATIVE_PROCEDURE:
        dispatch(resetPertinentNegativeProcedureState())
        return
    }
  }

  // useIonViewDidEnter(() => {
  //   dispatch(resetMedicationAdministeredState())
  // })

  return (
    <SingleSelectPage
      options={actionsList}
      action={onActionClick}
      backAction={onBackClick}
      dividerText={t('timeline.actions')}
      loading={false}
      listHeader={t('timeline.actions')}
      isAlphabeticalList={false}
    />
  )
}

export default ActionsSearch
